// import eventType from '$modules/eventType/routes'
// import eventDate from '$modules/eventDate/routes'
import eventDiscount from '$modules/eventDiscount/routes'
import sponsorship from '$modules/sponsorship/routes'
// import eventTeam from '$modules/eventTeam/routes'

export default [
  {
    path: 'event',
    meta: {
      title: 'Events',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'event_available'
    },
    component: () => import('./pages/index'),
    redirect: 'event/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'event',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'event',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'event',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      },
      {
        path: 'edit/:id/attendees',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit Attendees',
          resource: 'event',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/attendees')
      },
      {
        path: 'edit/:id/groups',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit Groups',
          resource: 'event',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/groups')
      }
    ].concat(eventDiscount, sponsorship)
  }
]
